import ModelFactory from 'business/models/ModelFactory';
import { HomeClient, ResponseDTO } from 'business/models/Models';

export type AutoUpdateJsonFormat = {
  version: string;
  url: string;
  release_notes: string;
};
export async function getAutoUpgradeJsonFromUrl(): Promise<ResponseDTO> {
  const updater: HomeClient = ModelFactory(HomeClient, false, true);
  const result = await updater.checkForUpdate();
  return result;
}

export async function getReleaseNotesFromUrl(url: string) {
  const updater: HomeClient = ModelFactory(HomeClient);
  const result = await updater.getReleaseNotes(url);
  return result;
}

export async function getAppVersion(): Promise<string> {
  const homeClient: HomeClient = ModelFactory(HomeClient, false, true);
  return await homeClient.getVersion();
}
